"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var React = require("react");
var Theme_1 = require("../../Theme");
var Spinner_styles_1 = require("./Spinner.styles");
var defaultSpinnerColor = Theme_1.Color.Grey.G60;
// For internal StarryUI component use.
var Spinner = function (_a) {
    var _b = _a.Size, Size = _b === void 0 ? "20px" : _b, _c = _a.Color, Color = _c === void 0 ? defaultSpinnerColor : _c, _d = _a.BorderSize, BorderSize = _d === void 0 ? "1px" : _d;
    return React.createElement(Spinner_styles_1.Loader, { Size: Size, Color: Color, BorderSize: BorderSize });
};
exports.Spinner = Spinner;
